import { toInteger } from 'lodash';
import React from 'react';
import { getLayerInnerStyle } from '@/utils/layer-kit';
import { ILayerProps, IMediaLayerProps, IRenderLayerEvent } from '@/version-types';

const MediaImage: React.FC<{ layer: ILayerProps; normalIcon?: boolean } & IRenderLayerEvent> = ({ layer }) => {
    const { opacity, width, height, id } = layer;
    const {
        url,
        imageTransform: { widthRatio, heightRatio, flipH, flipV, offsetX: offsetXRatio, offsetY: offsetYRatio, scale },
    } = layer.data as IMediaLayerProps;
    const originImgWidth = toInteger(width * widthRatio);
    const originImgHeight = toInteger(height * heightRatio);
    const offsetX = toInteger(offsetXRatio * originImgWidth * scale);
    const offsetY = toInteger(offsetYRatio * originImgHeight * scale);

    const innerStyle = getLayerInnerStyle(originImgWidth, originImgHeight, offsetX, offsetY, scale, flipH, flipV);

    return (
        <div
            style={{
                ...innerStyle,
                opacity,
            }}
        >
            <img
                src={url}
                style={{
                    width: '100%',
                    height: '100%',
                    display: 'block',
                }}
            />
        </div>
    );
};
export default React.memo(MediaImage);
